import $ from 'jquery';

import { AddressesForm } from './AddressesForm';

export class CreateAddressForm extends AddressesForm {
  constructor(container) {
    super(container);
  }
}
